import React from 'react';

import PropTypes from 'prop-types';
import { FaChevronDown } from 'react-icons/fa';
import styled from 'styled-components';

import {
  Dropdown,
  Button as BaseButton,
  useBreakpoint,
} from '~/techstyle-shared/react-components';
import {
  FormattedMessage,
  defineMessages,
  useIntl,
} from '~/techstyle-shared/react-intl';

import { useMemberModelContext } from '../EnhancedMemberModelProvider';

const CHEVRON_DIRECTIONS_MAP = { open: 'UP', close: 'DOWN' };

const DropdownButton = styled(Dropdown.Button)`
  ${({ theme: { pdpStyles } }) => pdpStyles.enhancedMemberModel.button.base}
`;

const ModalButton = styled(BaseButton).attrs({ variant: 'unstyled' })`
  ${({ theme: { pdpStyles } }) => pdpStyles.enhancedMemberModel.button.base}
`;

const Chevron = styled(FaChevronDown)`
  ${({ theme: { pdpStyles } }) => pdpStyles.enhancedMemberModel.button.chevron}
`;

const LabelWrapper = styled.span`
  ${({ theme: { pdpStyles } }) =>
    pdpStyles.enhancedMemberModel.button.labelWrapper}
`;
const DefaultLabel = () => {
  return (
    <FormattedMessage
      defaultMessage="Change Model"
      id="pdp_change_model.change_model"
    />
  );
};

const intlAriaLabel = defineMessages({
  dropdownButton: {
    id: 'site_pdp.member_model_dropdown_button_aria',
    defaultMessage: 'Member Model Open Dropdown',
  },
  modalButton: {
    id: 'site_pdp.member_model_modal_button_aria',
    defaultMessage: 'Member Model Open Modal',
  },
});

export default function MemberModelButton({
  label = <DefaultLabel />,
  ariaLabel = intlAriaLabel.dropdownButton,
}) {
  const { isModalOpen, openModal } = useMemberModelContext();
  const { isMobile } = useBreakpoint();
  const intl = useIntl();
  const Button = isMobile ? ModalButton : DropdownButton;

  if (isMobile) {
    ariaLabel = intlAriaLabel.modalButton;
  }

  return (
    <Button
      data-expanded={isModalOpen}
      onClick={openModal}
      data-autotag="pdp-modal-styledSelect"
      aria-label={intl.formatMessage(ariaLabel)}
    >
      <LabelWrapper>{label}</LabelWrapper>
      <Chevron
        size="14px"
        $direction={
          (isModalOpen && CHEVRON_DIRECTIONS_MAP.open) ||
          CHEVRON_DIRECTIONS_MAP.close
        }
      />
    </Button>
  );
}

MemberModelButton.propTypes = {
  ariaLabel: PropTypes.string || PropTypes.any,
  label: PropTypes.node,
};
